module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "content-box"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('plexRemoved')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('plexRemovedInfo')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('visitMethods')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('firstMethod')))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('secondMethod')))]), _c('router-link', {
    attrs: {
      "to": _vm.currentUrl
    }
  }, [_vm._v(_vm._s(_vm.currentUrl))])], 1), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('suggest')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67408828!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPage/iosReach/Index.vue
// module id = 1342
// module chunks = 1